'use strict';
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);
const RVL_CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
const RVL_RATE = Number(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
const RVL_MONEY = new Intl.NumberFormat('en-GB', { style: 'currency', currency: RVL_CURRENCY });
/* cents already in the customer's currency (e.g. /cart.js) */
function formatMoney(cents) { return RVL_MONEY.format((Number(cents) || 0) / 100); }
/* cents in the shop currency (e.g. product JSON, /recommendations) converted to the market currency */
function formatShopMoney(cents) { return formatMoney(Math.round((Number(cents) || 0) * RVL_RATE)); }

(function initNavbarScroll(){
  const navbar = $('.navbar'); if (!navbar) return;
  const update = () => navbar.classList.toggle('scrolled', window.scrollY > 20);
  on(window, 'scroll', update, { passive: true }); update();
})();

(function initMegaMenu(){
  $$('.nav-item').forEach(item => {
    let timer; const menu = item.querySelector('.mega-menu'); if (!menu) return;
    on(item, 'mouseenter', () => { clearTimeout(timer); item.classList.add('open'); });
    on(item, 'mouseleave', () => { timer = setTimeout(() => item.classList.remove('open'), 120); });
    const trigger = item.querySelector('.nav-link');
    on(trigger, 'keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.classList.toggle('open'); }
      if (e.key === 'Escape') item.classList.remove('open');
    });
  });
  on(document, 'click', e => { if (!e.target.closest('.nav-item')) $$('.nav-item').forEach(i => i.classList.remove('open')); });
})();

function openMobileMenu() { $('#mobile-nav')?.classList.add('open'); $('#overlay')?.classList.add('active'); document.body.style.overflow = 'hidden'; }
function closeMobileMenu() { $('#mobile-nav')?.classList.remove('open'); $('#overlay')?.classList.remove('active'); document.body.style.overflow = ''; }
(function initMobileNav(){
  on($('.hamburger'), 'click', openMobileMenu);
  on($('.mobile-nav__close'), 'click', closeMobileMenu);
  on(document, 'keydown', e => { if (e.key === 'Escape') closeMobileMenu(); });
})();

function showToast(message, type = '', duration = 2800) {
  const toast = $('#toast'); if (!toast) return;
  toast.textContent = message;
  toast.className = 'toast show' + (type ? ' toast--' + type : '');
  clearTimeout(toast._timer);
  toast._timer = setTimeout(() => { toast.className = 'toast'; }, duration);
}

/* ===== CART REDESIGN ===== */
/* Rivelia cart drawer visibility and quantity fix */
function paymentLogosHtml() {
  const template = document.getElementById('drawer-payment-logos-template');
  if (template && template.innerHTML.trim()) return template.innerHTML;
  return '<div class="cart-drawer-payment-label">Accepted payments</div>';
}

const RIVELIA_PROTECTION_VARIANT_ID = 54219855659355;

const Cart = {
  async getCart() { const res = await fetch('/cart.js'); return res.json(); },
  async addItem(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity }) });
    if (!res.ok) { let msg = 'Product unavailable'; try { const err = await res.json(); msg = err.description || err.message || msg; } catch(e) {} throw new Error(msg); }
    return res.json();
  },
  async removeItem(key) {
    const res = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
    return res.json();
  },
  async changeItem(key, quantity) {
    const res = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }) });
    return res.json();
  },
  async render() {
    const cart = await this.getCart();
    this.updateCount(cart.item_count);
    const body = $('#cart-drawer-body');
    const footer = $('#cart-drawer-footer');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="cart-empty">
          <div class="cart-empty__title">Your basket is empty</div>
          <p class="cart-empty__text">Discover our selection<br>of elegant pieces.</p>
          <a href="/collections" class="btn btn--dark" onclick="toggleCart(false)" style="display:inline-flex;padding:12px 28px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;font-weight:600">View our collections</a>
        </div>`;
      if (footer) footer.innerHTML = '';
      return;
    }

        /* MULTI-ITEM DISCOUNT PROGRESS BAR */
    var goalHtml = '';
    var qty = cart.items.reduce(function(sum, item) {
      return Number(item.variant_id) === RIVELIA_PROTECTION_VARIANT_ID ? sum : sum + item.quantity;
    }, 0);

    var pct = Math.min(100, (qty / 4) * 100);
    var label = '';

    if (qty < 2) {
      var remaining15 = 2 - qty;
      label = 'Add ' + remaining15 + ' more item' + (remaining15 > 1 ? 's' : '') + ' and get <strong>-15%</strong>';
    } else if (qty === 2) {
      label = '✓ <strong>-15%</strong> unlocked · add 1 more item to get <strong>-20%</strong>';
    } else if (qty === 3) {
      label = '✓ <strong>-20%</strong> unlocked · add 1 more item to get <strong>-25%</strong>';
    } else {
      label = '✓ Maximum <strong>-25%</strong> unlocked';
    }

    goalHtml = `
      <div class="cart-goal${qty >= 4 ? ' cart-goal--done' : ''}">
        <div class="cart-goal__text">${label}</div>
        <div class="cart-goal__track">
          <div class="cart-goal__fill" style="width:${pct}%"></div>
          <div class="cart-goal__milestone ${qty >= 2 ? 'is-reached' : ''}" style="left:50%"><span>2</span></div>
          <div class="cart-goal__milestone ${qty >= 3 ? 'is-reached' : ''}" style="left:75%"><span>3</span></div>
          <div class="cart-goal__milestone ${qty >= 4 ? 'is-reached' : ''}" style="left:100%"><span>4</span></div>
        </div>
        <div class="cart-goal__labels">
          <span style="left:50%">-15%</span>
          <span style="left:75%">-20%</span>
          <span style="left:100%">-25%</span>
        </div>
      </div>`;

    var visualTierRate = qty >= 4 ? 0.25 : (qty >= 3 ? 0.20 : (qty >= 2 ? 0.15 : 0));
    var eligibleBaseSubtotal = cart.items.reduce(function(sum, item) {
      if (Number(item.variant_id) === RIVELIA_PROTECTION_VARIANT_ID) return sum;
      return sum + Number(item.original_line_price || item.final_line_price || 0);
    }, 0);
    var protectionSubtotal = cart.items.reduce(function(sum, item) {
      if (Number(item.variant_id) !== RIVELIA_PROTECTION_VARIANT_ID) return sum;
      return sum + Number(item.final_line_price || item.original_line_price || 0);
    }, 0);
    var visualTierSavings = Math.round(eligibleBaseSubtotal * visualTierRate);
    var visualCartTotal = eligibleBaseSubtotal - visualTierSavings + protectionSubtotal;

    function drawerPriceHtml(item) {
      var baseLine = Number(item.original_line_price || item.final_line_price || 0);

      if (Number(item.variant_id) === RIVELIA_PROTECTION_VARIANT_ID) {
        var protectionLine = Number(item.final_line_price || item.original_line_price || 0);
        return '<span class="cart-item__price">' + formatMoney(protectionLine) + '</span>';
      }

      /* Only the genuine multi-item discount is shown: the struck-through price is the real current price. */
      if (visualTierRate <= 0) {
        return '<span class="cart-item__price">' + formatMoney(baseLine) + '</span>';
      }
      var visualCurrentLine = Math.round(baseLine * (1 - visualTierRate));

      return `
        <span class="cart-item__price-stack">
          <span class="cart-item__price-old">${formatMoney(baseLine)}</span>
          <span class="cart-item__price cart-item__price-current">${formatMoney(visualCurrentLine)}</span>
        </span>`;
    }

    /* ITEMS */
    body.innerHTML = goalHtml + cart.items.map(item => `
      <div class="cart-item">
        <a href="${item.url}"><img class="cart-item__img" src="${item.image}" alt="${item.title}" loading="lazy" width="80" height="107"></a>
        <div class="cart-item__info">
          <div>
            <div class="cart-item__vendor">${item.vendor}</div>
            <div class="cart-item__name">${item.product_title}</div>
            ${item.variant_title !== 'Default Title' ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
          </div>
          <div class="cart-item__bottom">
            <div class="cart-item__qty" aria-label="Quantity">
              <button type="button" class="cart-item__qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" class="cart-item__qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase quantity">+</button>
            </div>
            <div style="display:flex;align-items:center;gap:12px">
              ${drawerPriceHtml(item)}
              <span class="cart-item__remove" data-key="${item.key}">Remove</span>
            </div>
          </div>
        </div>
      </div>`).join('');

    body.onclick = async event => {
      const removeButton = event.target.closest('.cart-item__remove');
      if (removeButton) { await this.removeItem(removeButton.dataset.key); await this.render(); return; }
      const quantityButton = event.target.closest('.cart-item__qty-btn');
      if (quantityButton) { await this.changeItem(quantityButton.dataset.key, Number(quantityButton.dataset.qty)); await this.render(); }
    };

    /* FOOTER */
    if (footer) {
      footer.innerHTML = `
        ${visualTierSavings > 0 ? `<div class="cart-savings">You save <strong>${formatMoney(visualTierSavings)}</strong> with the Halloween offer</div>` : ''}
<div class="cart-total"><span>Total</span><span>${formatMoney(visualCartTotal)}</span></div>

        <a href="/checkout" class="cart-drawer-checkout">Secure checkout</a>
        <div class="cart-drawer-checkout-sub">
          <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          Secure payment via Shopify Payments
        </div>
        <a href="/collections" class="cart-drawer-continue" onclick="toggleCart(false)">&#8592; Continue shopping</a>
        ${paymentLogosHtml()}
            <div class="cart-drawer-payment" style="display:none">
          <div class="cart-drawer-payment-label">
            <svg width="10" height="10" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
            Accepted payments
          </div>
          <div class="cart-drawer-logos">
            <span class="cart-drawer-logo" title="Visa"><svg viewBox="0 0 48 16" xmlns="http://www.w3.org/2000/svg"><path d="M18.6 1.1L12 14.9h-3.9L4.7 4.3C4.5 3.5 4.2 3 3.6 2.7 2.7 2.2 1.3 1.7 0 1.4l.1-.3h6.3c.8 0 1.5.6 1.7 1.4l1.6 8.3 3.9-9.7h3.9zm15.4 9.3c0-3.8-5.2-4-5.2-5.7 0-.5.5-1.1 1.6-1.2 1.4-.1 2.4.2 3.2.5l.6-2.7C33.4.9 32.3.6 31 .6c-3.7 0-6.3 2-6.3 4.8 0 2.1 1.9 3.2 3.3 3.9 1.5.7 2 1.2 2 1.8 0 1-1.2 1.4-2.3 1.4-1.4 0-2.6-.3-3.6-.8l-.6 2.8c1 .4 2.4.7 4 .7 3.9 0 6.4-1.9 6.5-4.8zm9.7 4.5H48L45.1.6h-3.3c-.7 0-1.4.4-1.7 1.1l-5.5 13.2h3.9l.8-2.1h4.7zm-3.3-4l1.9-5.3.7 3.5-2.6 1.8zm-15.7-9L21.5 14.9h-3.7L21 .7h3.7z" fill="#1A1F71"/></svg></span>
            <span class="cart-drawer-logo" title="Mastercard"><svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg"><circle cx="14" cy="12" r="10" fill="#EB001B"/><circle cx="24" cy="12" r="10" fill="#F79E1B"/><path d="M19 4.5a10 10 0 0 1 0 15A10 10 0 0 1 19 4.5z" fill="#FF5F00"/></svg></span>
            <span class="cart-drawer-logo" title="PayPal"><svg viewBox="0 0 48 16" xmlns="http://www.w3.org/2000/svg"><path d="M6 1h5.5c2.5 0 3.7 1.3 3.5 3.3-.3 2.4-2 3.7-4.4 3.7H9l-.7 4H5.5L6 1zm2.5 5h1.5c1 0 1.7-.5 1.8-1.5.1-.7-.3-1.1-1.2-1.1H9l-.5 2.6z" fill="#003087"/><path d="M15 1h5.5c2.5 0 3.7 1.3 3.5 3.3-.3 2.4-2 3.7-4.4 3.7H18l-.7 4H14.5L15 1zm2.5 5h1.5c1 0 1.7-.5 1.8-1.5.1-.7-.3-1.1-1.2-1.1H18l-.5 2.6z" fill="#009CDE"/></svg></span>
            <span class="cart-drawer-logo" title="Apple Pay"><svg viewBox="0 0 52 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.8 3.8c-.6.7-1.5 1.2-2.4 1.1-.1-.9.3-1.8.8-2.4.6-.7 1.6-1.2 2.4-1.3.1.9-.2 1.8-.8 2.6zm.8 1.3c-1.3-.1-2.5.8-3.1.8S5.4 5 4.2 5C2.8 5.1 1.5 5.9.8 7.1c-1.4 2.5-.4 6.2 1 8.2.7 1 1.5 2.1 2.6 2.1s1.4-.6 2.7-.6 1.5.6 2.7.6 1.8-1 2.5-2c.8-1.1 1.1-2.2 1.1-2.3 0 0-2.1-.8-2.1-3.2 0-2 1.7-3 1.7-3.1-.9-1.3-2.3-1.5-2.9-1.6zM19 5v10h2.3V11h3.1c2.8 0 4.8-1.9 4.8-4.7 0-2.7-1.9-4.6-4.7-4.6H19zm2.3 2h2.6c1.9 0 3 1 3 2.7s-1.1 2.7-3 2.7h-2.6V7z" fill="#000"/></svg></span>
            <span class="cart-drawer-logo" title="" style="display:none"><svg viewBox="0 0 52 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.7 9.2c0-.3 0-.6-.1-.9H6.5v1.7H9.4c-.1.7-.5 1.3-1 1.7v1.4h1.7c1-.9 1.6-2.3 1.6-3.9z" fill="#4285F4"/><path d="M6.5 13.7c1.5 0 2.7-.5 3.6-1.4l-1.7-1.3c-.5.3-1.1.5-1.9.5-1.4 0-2.6-1-3-2.3H1.7v1.4c.9 1.7 2.7 3.1 4.8 3.1z" fill="#34A853"/><path d="M3.5 9.2c-.2-.6-.2-1.3 0-1.9V5.9H1.7a5.6 5.6 0 0 0 0 6.2L3.5 10.7V9.2z" fill="#FBBC04"/><path d="M6.5 5c.8 0 1.5.3 2.1.8l1.5-1.5C9 3.3 7.8 2.8 6.5 2.8 4.4 2.8 2.6 4 1.7 5.9l1.8 1.4C4 6 5.1 5 6.5 5z" fill="#EA4335"/></svg></span>
          </div>
        </div>`;
    }
  },
  updateCount(count) { $$('.cart-count').forEach(el => { el.textContent = count; el.classList.toggle('hidden', count === 0); }); }
};

function toggleCart(open) {
  const drawer = $('#cart-drawer'); const overlay = $('#overlay'); if (!drawer) return;
  const isOpen = open !== undefined ? open : !drawer.classList.contains('open');
  drawer.classList.toggle('open', isOpen); overlay?.classList.toggle('active', isOpen);
  document.body.classList.toggle('cart-open', isOpen);
  document.body.style.overflow = isOpen ? 'hidden' : '';
  if (isOpen) Cart.render();
}

(function initCart(){
  $$('[data-cart-toggle]').forEach(btn => on(btn, 'click', () => toggleCart()));
  on($('#cart-drawer'), 'click', e => { if (e.target === e.currentTarget) toggleCart(false); });
  Cart.getCart().then(c => Cart.updateCount(c.item_count));
})();

(function initProductForm(){
  const form = $('[data-product-form]'); if (!form) return;
  on(form, 'submit', async e => {
    e.preventDefault();
    const btn = form.querySelector('[data-atc-btn]');
    const variantId = parseInt(form.querySelector('[name="id"]').value);
    btn.classList.add('btn--loading'); btn.disabled = true;
    try {
      await Cart.addItem(variantId, parseInt(form.querySelector('[name="quantity"]')?.value || 1));
      showToast('Added to cart', 'success');
      Cart.render();
      setTimeout(() => toggleCart(true), 400);
    } catch (err) { showToast(err.message, 'error'); }
    finally { btn.classList.remove('btn--loading'); btn.disabled = false; }
  });
})();

/* Rivelia: dispatch estimate (+2 working days) */
(function initShippingEstimate(){
  const dateEl = document.querySelector('[data-shipping-estimate-date]');
  if (!dateEl) return;

  function addBusinessDays(date, days) {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return result;
  }

  const target = addBusinessDays(new Date(), 2);
  const formatted = target.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' });
  dateEl.textContent = formatted.charAt(0).toUpperCase() + formatted.slice(1);
})();

(function initVariantSelector(){
  const container = document.querySelector('[data-product-container]'); if (!container) return;
  const productData = JSON.parse(document.querySelector('[data-product-json]')?.textContent || '{}');
  if (!productData.variants) return;
  const colorMap = {'noir':'#111111','black':'#111111','blanc':'#FFFFFF','white':'#FFFFFF','beige':'#F5EDD6','creme':'#FFF8E7','écru':'#F3EBDD','ecru':'#F3EBDD','ivoire':'#FFFFF0','rouge':'#C0392B','red':'#C0392B','bleu':'#2C5F8A','blue':'#2C5F8A','marine':'#1F2A44','navy':'#1F2A44','vert':'#2E7D32','green':'#2E7D32','rose':'#F48FB1','pink':'#F48FB1','gris':'#9E9E9E','grey':'#9E9E9E','marron':'#795548','brown':'#795548','bordeaux':'#7B1829','orange':'#E65100','jaune':'#F9A825','yellow':'#F9A825','violet':'#7B1FA2','purple':'#7B1FA2','or':'#CFB53B','doré':'#CFB53B','dore':'#CFB53B','argent':'#C0C0C0','silver':'#C0C0C0','camel':'#C19A6B','kaki':'#6B6B3A','khaki':'#6B6B3A','brun':'#795548','taupe':'#8B7D6B','blanc cassé':'#FFF8E1','blanc casse':'#FFF8E1','gris bleu':'#7986CB','marron caramel':'#A1665A','cream':'#FFF8E7','ivory':'#FFFFF0','gold':'#CFB53B','tan':'#C19A6B','burgundy':'#7B1829','charcoal':'#36454F','nude':'#E3BC9A','off white':'#FFF8E1','off-white':'#FFF8E1','light blue':'#ADD8E6','dark blue':'#1F2A44','light grey':'#D3D3D3','dark grey':'#555555','beige':'#F5EDD6','chocolate':'#5D3A1A','coffee':'#6F4E37','apricot':'#FBCEB1','coral':'#FF7F50','mint':'#98FF98','lilac':'#C8A2C8','mustard':'#E1AD01','olive':'#708238','wine':'#722F37','champagne':'#F7E7CE'};
  const colorWords=Object.keys(colorMap).concat(['multicolore','multicolour','multicolor','multi','imprimé','imprime','print','printed','léopard','leopard','animal','fleuri','fleurie','floral','zebra','zèbre']);
  function cleanText(raw){return (raw||'').replace(' 10 cm','').replace(' 8 cm','').trim();}
  function norm(raw){return cleanText(raw).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'');}
  function optionNameFromInput(input){const attr=input?.getAttribute('name')||'';const match=attr.match(/options\[(.*)\]/);return match?match[1]:'';}
  function optionNameFor(section,optionIndex){return productData.options?.[optionIndex]?.name||productData.options?.[optionIndex]||optionNameFromInput(section.querySelector('[data-variant-option]'))||section.querySelector('.variant-label span,.product-option-label span')?.textContent?.split(':')[0]||'';}
  function isSizeValue(raw){const val=norm(raw);return /^\d+(\.\d+)?$/.test(val)||['xs','s','m','l','xl','2xl','3xl','xxl','xxxl','4xl','5xl','unique','tu','taille unique','one size','onesize','os'].includes(val);}
  function isSizeName(raw){const val=norm(raw);return /taille|size|pointure|shoe size|chaussure/.test(val);}
  function isColorName(raw){const val=norm(raw);return /couleur|color|colour|coloris|teinte|variante/.test(val);}
  function valuesForSection(section){return Array.from(section.querySelectorAll('[data-variant-option]')).map(input=>input.value||'');}
  function looksLikeColorValues(values){if(!values.length)return false;let hits=0;values.forEach(value=>{const v=norm(value);if(colorWords.some(word=>v.includes(norm(word))))hits++;});return hits>0&&hits>=Math.ceil(values.length/2);}
  function hasVariantImagesForOption(optionIndex,values){const seen=new Set();values.forEach(v=>seen.add(norm(v)));let withImages=0;seen.forEach(value=>{const match=productData.variants.find(variant=>norm([variant.option1,variant.option2,variant.option3][optionIndex])===value&&variant.featured_image);if(match)withImages++;});return withImages>0;}
  function shouldRenderAsColor(section,optionIndex){const name=optionNameFor(section,optionIndex);const values=valuesForSection(section);if(section.querySelector('.color-options'))return true;if(isColorName(name))return !isSizeName(name);if(isSizeName(name))return false;if(looksLikeColorValues(values))return true;if(hasVariantImagesForOption(optionIndex,values)&&!values.every(isSizeValue))return true;return false;}
  function injectVariantStyles(){if(document.getElementById('rivelia-variant-style'))return;const style=document.createElement('style');style.id='rivelia-variant-style';style.textContent='.product-variant-block{margin-bottom:18px}.product-option-label{display:flex;justify-content:space-between;align-items:center;gap:12px;margin-bottom:10px;font-size:12px!important;font-weight:600!important;letter-spacing:.08em;text-transform:uppercase;color:#111}.product-option-label__value{font-weight:500;letter-spacing:.02em;text-transform:none;color:#555}.product-color-swatches{display:flex;flex-wrap:wrap;gap:10px}.product-color-swatch{position:relative;display:block;cursor:pointer}.product-color-swatch__button{display:block!important;width:60px!important;height:60px!important;min-width:60px!important;border:1px solid #E5E0D8!important;background:#fff!important;border-radius:3px!important;overflow:hidden!important;padding:0!important;cursor:pointer;transition:border-color .15s,box-shadow .15s,transform .15s;font-size:0!important;line-height:0!important}.product-color-swatch__button.active{border:2px solid #111!important;box-shadow:0 0 0 1px #111!important}.product-color-swatch:hover .product-color-swatch__button{border-color:#111!important}.product-color-swatch__image{width:100%;height:100%;object-fit:cover;object-position:center;display:block}.product-size-buttons{display:flex;flex-wrap:wrap;gap:8px}.product-size-button{cursor:pointer;position:relative}.product-size-button__label{display:inline-flex!important;align-items:center;justify-content:center;min-width:46px!important;height:44px!important;padding:0 12px!important;border:1px solid #E5E0D8!important;background:#fff!important;font-size:13px!important;color:#111!important;cursor:pointer;transition:all .15s;border-radius:2px!important;text-decoration:none!important;line-height:1!important}.product-size-button__label:hover{border-color:#111!important}.product-size-button__label.active{border-color:#111!important;background:#111!important;color:#fff!important}.product-size-button__label.soldout,.product-color-swatch__button.soldout{opacity:.35;cursor:not-allowed}.product-variant-input{position:absolute!important;opacity:0!important;width:1px!important;height:1px!important;margin:0!important;pointer-events:none!important}@media(max-width:768px){.product-variant-block{margin-bottom:16px}.product-color-swatches,.product-size-buttons{gap:8px}.product-color-swatch__button{width:56px!important;height:56px!important;min-width:56px!important}.product-size-button__label{min-width:43px!important;height:42px!important}}';document.head.appendChild(style);}
  function variantImageFor(optionIndex,value){const val=norm(value);const match=productData.variants.find(v=>norm([v.option1,v.option2,v.option3][optionIndex])===val&&v.featured_image)||productData.variants.find(v=>norm([v.option1,v.option2,v.option3][optionIndex])===val);const image=match?.featured_image||productData.featured_image||productData.images?.[0];let src=image?.src||image;if(src&&src.startsWith('//'))src='https:'+src;return src||'';}
  function normalizeLabel(section,optionIndex){const labelRow=section.querySelector('.variant-label,.product-option-label');if(!labelRow)return;const selected=section.querySelector('[data-variant-option]:checked');const selectedText=cleanText(selected?.value||'');let name=optionNameFor(section,optionIndex);if(shouldRenderAsColor(section,optionIndex))name='Colour';else if(isSizeName(name)||valuesForSection(section).every(isSizeValue))name='Size';if(!labelRow.querySelector('[data-option-selected-label]')){const nameEl=labelRow.querySelector('span')||labelRow;if(nameEl){nameEl.innerHTML=cleanText(name).toUpperCase()+' : <span class="product-option-label__value" data-option-selected-label data-option-index="'+optionIndex+'">'+selectedText+'</span>';}}labelRow.classList.add('product-option-label');}
  function enhanceVariantMarkup(){injectVariantStyles();container.querySelectorAll('.variant-section').forEach(section=>{const inputs=section.querySelectorAll('[data-variant-option]');if(!inputs.length)return;section.classList.add('product-variant-block');const firstInput=inputs[0];const optionIndex=parseInt(firstInput.dataset.optionIndex||'0',10);const renderAsColor=shouldRenderAsColor(section,optionIndex);normalizeLabel(section,optionIndex);const group=section.querySelector('.color-options,.variant-options');if(renderAsColor){if(group){group.classList.remove('product-size-buttons');group.classList.add('product-color-swatches');}
      section.querySelectorAll('label').forEach(label=>{const input=label.querySelector('[data-variant-option]');const swatch=label.querySelector('.color-option,.variant-option');if(!input||!swatch)return;const display=cleanText(swatch.dataset.optionLabel||input.value||'');label.classList.remove('product-size-button');label.classList.add('product-color-swatch');label.setAttribute('aria-label','Colour '+display);input.classList.add('product-variant-input');swatch.classList.remove('product-size-button__label');swatch.classList.add('product-color-swatch__button');swatch.dataset.optionLabel=display;swatch.textContent='';if(!swatch.querySelector('img')){const src=variantImageFor(optionIndex,input.value);if(src){const img=document.createElement('img');img.className='product-color-swatch__image';img.src=src;img.alt=display;img.loading='lazy';swatch.appendChild(img);}}});
    }else{if(group){group.classList.remove('product-color-swatches');group.classList.add('product-size-buttons');}
      section.querySelectorAll('label').forEach(label=>{const input=label.querySelector('[data-variant-option]');const btn=label.querySelector('.variant-option,.color-option');if(!input||!btn)return;const display=cleanText(btn.dataset.optionLabel||input.value||'');label.classList.remove('product-color-swatch');label.classList.add('product-size-button');label.setAttribute('aria-label',optionNameFor(section,optionIndex)+' '+display);input.classList.add('product-variant-input');btn.classList.remove('product-color-swatch__button');btn.classList.add('product-size-button__label');btn.dataset.optionLabel=display;btn.textContent=display;});}});}
  function selectedValues(){return Array.from(container.querySelectorAll('[data-variant-option]:checked')).map(input=>norm(input.value));}
  function findSelectedVariant(){const selected=selectedValues();return productData.variants.find(v=>[v.option1,v.option2,v.option3].filter(Boolean).map(o=>norm(o)).every((opt,i)=>!selected[i]||opt===selected[i]));}
  function syncOptionLabels(){container.querySelectorAll('[data-variant-option]:checked').forEach(input=>{const label=container.querySelector('[data-option-selected-label][data-option-index="'+input.dataset.optionIndex+'"]');if(label){const visual=input.closest('label')?.querySelector('[data-option-label],.product-color-swatch__button,.product-size-button__label');label.textContent=cleanText(visual?.dataset.optionLabel||input.value||'');}});}
  function updateUI(variant){
    if(!variant)return;
    const priceEl=container.querySelector('[data-product-price]');
    const oldPriceEl=container.querySelector('[data-product-compare-price]');
    if(priceEl)priceEl.textContent=formatShopMoney(variant.price);
    if(oldPriceEl){
      if(variant.compare_at_price>variant.price){
        oldPriceEl.textContent=formatShopMoney(variant.compare_at_price);
        oldPriceEl.style.display='';
      }else{
        oldPriceEl.style.display='none';
      }
    }
    const atcBtn=container.querySelector('[data-atc-btn]');
    if(atcBtn){atcBtn.disabled=!variant.available;atcBtn.textContent=variant.available?'Add to cart':'Sold out';}
    const idInput=container.querySelector('[name="id"]');
    if(idInput)idInput.value=variant.id;
    if(variant.featured_image){
      const mainImg=container.querySelector('[data-gallery-main]');
      if(mainImg){
        let src=variant.featured_image.src;
        if(src.startsWith('//'))src='https:'+src;
        mainImg.src=src;
      }
    }
    const url=new URL(window.location.href);
    url.searchParams.set('variant',variant.id);
    window.history.replaceState({},'',url.toString());
  }
  function refreshUnavailable(){const selected=selectedValues();container.querySelectorAll('[data-variant-option]').forEach(input=>{const optionIndex=parseInt(input.dataset.optionIndex||'0',10);const test=selected.slice();test[optionIndex]=norm(input.value);const available=productData.variants.some(v=>v.available&&[v.option1,v.option2,v.option3].filter(Boolean).map(o=>norm(o)).every((opt,i)=>!test[i]||opt===test[i]));const visual=input.closest('label')?.querySelector('.product-color-swatch__button,.product-size-button__label,.color-option,.variant-option');if(visual)visual.classList.toggle('soldout',!available);input.disabled=!available&&!input.checked;});}
  function selectVisual(btn){const input=btn.closest('label')?.querySelector('[data-variant-option]');if(input&&!input.disabled)input.checked=true;const group=btn.closest('.variant-options,.color-options,.product-color-swatches,.product-size-buttons');if(group)group.querySelectorAll('.color-option,.variant-option,.product-color-swatch__button,.product-size-button__label').forEach(b=>{if(b.tagName!=='INPUT')b.classList.remove('active');});btn.classList.add('active');syncOptionLabels();const match=findSelectedVariant();if(match)updateUI(match);refreshUnavailable();}
  container.addEventListener('click',function(e){const btn=e.target.closest('.product-color-swatch__button,.product-size-button__label,.color-option,.variant-option');if(!btn||btn.tagName==='INPUT')return;selectVisual(btn);});
  container.addEventListener('change',function(e){const input=e.target.closest('[data-variant-option]');if(!input)return;const visual=input.closest('label')?.querySelector('.product-color-swatch__button,.product-size-button__label,.color-option,.variant-option');if(visual)selectVisual(visual);});
  enhanceVariantMarkup();
  syncOptionLabels();
  const urlVariantId=new URLSearchParams(window.location.search).get('variant');
  const initVariant=productData.variants.find(v=>String(v.id)===urlVariantId)||findSelectedVariant()||productData.variants.find(v=>v.available)||productData.variants[0];
  if(initVariant){updateUI(initVariant);container.querySelectorAll('[data-variant-option]').forEach(input=>{const value=norm(input.value);const optionIndex=parseInt(input.dataset.optionIndex||'0',10);if(norm([initVariant.option1,initVariant.option2,initVariant.option3][optionIndex])===value){input.checked=true;const visual=input.closest('label')?.querySelector('.product-color-swatch__button,.product-size-button__label,.color-option,.variant-option');if(visual){const group=visual.closest('.variant-options,.color-options,.product-color-swatches,.product-size-buttons');if(group)group.querySelectorAll('.color-option,.variant-option,.product-color-swatch__button,.product-size-button__label').forEach(b=>b.classList.remove('active'));visual.classList.add('active');}}});syncOptionLabels();refreshUnavailable();}
})();

(function initGallery(){
  const gallery=$('[data-gallery]'); if(!gallery)return;
  const mainImg=$('[data-gallery-main]',gallery);
  const thumbs=$$('[data-gallery-thumb]',gallery);
  thumbs.forEach(thumb=>{on(thumb,'click',function(){thumbs.forEach(t=>t.classList.remove('active'));this.classList.add('active');if(mainImg){mainImg.src=this.dataset.src;mainImg.alt=this.dataset.alt||'';}});});
})();

(function initQuantity(){
  $$('[data-qty-selector]').forEach(selector=>{
    const input=$('input',selector);
    on($('[data-qty-minus]',selector),'click',()=>{if(!input)return;const val=parseInt(input.value)||1;if(val>1)input.value=val-1;});
    on($('[data-qty-plus]',selector),'click',()=>{if(!input)return;const val=parseInt(input.value)||1;input.value=val+1;});
  });
})();

/* ACCORDION */
document.addEventListener('click',function(e){
  const header=e.target.closest('.accordion-header');
  if(!header)return;
  const item=header.closest('.accordion-item');
  if(!item)return;
  const wasOpen=item.classList.contains('open');
  const parent=item.parentElement;
  if(parent)parent.querySelectorAll(':scope > .accordion-item').forEach(i=>i.classList.remove('open'));
  if(!wasOpen)item.classList.add('open');
});

/* RECOMMANDATIONS */
(function initReco(){
  if(!window.location.pathname.includes('/products/'))return;
  const jsonEl=document.querySelector('[data-product-json]'); if(!jsonEl)return;
  let pid; try{pid=JSON.parse(jsonEl.textContent).id;}catch(e){return;}
  if(!pid)return;
  const style=document.createElement('style');
  style.textContent='.elora-reco{border-top:.5px solid #E5E0D8;padding:48px 24px 64px;max-width:1200px;margin:0 auto}.elora-reco__title{font-size:13px;font-weight:500;color:#111;margin-bottom:24px;text-transform:uppercase;letter-spacing:.08em}.elora-reco__grid{display:grid;grid-template-columns:repeat(4,1fr);gap:12px}@media(max-width:768px){.elora-reco__grid{grid-template-columns:repeat(2,1fr)}}.elora-reco__card{border:.5px solid #E5E0D8;border-radius:4px;overflow:hidden;text-decoration:none;display:block;transition:box-shadow .2s}.elora-reco__card:hover{box-shadow:0 4px 16px rgba(0,0,0,.08)}.elora-reco__img{aspect-ratio:3/4;overflow:hidden;background:#F8F5F0}.elora-reco__img img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .3s}.elora-reco__card:hover .elora-reco__img img{transform:scale(1.04)}.elora-reco__info{padding:10px 12px}.elora-reco__name{font-size:12px;color:#111;line-height:1.4;margin-bottom:4px;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}.elora-reco__price{font-size:13px;font-weight:500;color:#111}';
  document.head.appendChild(style);
  fetch('/recommendations/products.json?product_id='+pid+'&limit=4&intent=related')
    .then(r=>r.json())
    .then(data=>{
      if(!data.products||data.products.length===0)return;
      const section=document.createElement('div'); section.className='elora-reco';
      const title=document.createElement('div'); title.className='elora-reco__title'; title.textContent='You may also like'; section.appendChild(title);
      const grid=document.createElement('div'); grid.className='elora-reco__grid';
      data.products.slice(0,4).forEach(p=>{
        const img=p.images&&p.images[0]?p.images[0].src.replace('http://','https://'):'';
        const price=formatShopMoney(p.variants[0].price);
        const a=document.createElement('a'); a.href='/products/'+p.handle; a.className='elora-reco__card';
        a.innerHTML='<div class="elora-reco__img">'+(img?'<img src="'+img+'" alt="'+p.title.replace(/"/g,'&quot;')+'" loading="lazy">':'')+'</div><div class="elora-reco__info"><div class="elora-reco__name">'+p.title+'</div><div class="elora-reco__price">'+price+'</div></div>';
        grid.appendChild(a);
      });
      section.appendChild(grid);
      const anchor=document.querySelector('[data-product-container]');
      if(anchor&&anchor.parentNode)anchor.parentNode.insertBefore(section,anchor.nextSibling);
      else{const main=document.querySelector('main,#MainContent,[role="main"]');if(main)main.appendChild(section);}
    }).catch(()=>{});
})();

function switchTab(event,tabId){const btn=event.currentTarget;const switcher=btn.closest('.tab-switcher');const section=switcher?.parentElement;if(!section)return;switcher.querySelectorAll('.tab-btn').forEach(b=>b.classList.remove('active'));btn.classList.add('active');section.querySelectorAll('.tab-panel').forEach(p=>p.classList.remove('active'));section.querySelector('#tab-'+tabId)?.classList.add('active');}

(function initCollectionFilters(){
  on($('[data-filters-toggle]'),'click',()=>{const filters=$('.filters');const overlay=$('#overlay');if(!filters)return;filters.classList.add('open');overlay?.classList.add('active');});
  on($('[data-filters-close]'),'click',()=>{$('.filters')?.classList.remove('open');$('#overlay')?.classList.remove('active');});
  on($('[data-sort-select]'),'change',function(){const url=new URL(window.location.href);url.searchParams.set('sort_by',this.value);window.location.href=url.toString();});
  on($('[data-filter-form]'),'change',function(){this.requestSubmit();});
})();

function openSizeGuide(){$('#size-guide-modal')?.classList.add('open');document.body.style.overflow='hidden';}
function closeSizeGuide(){$('#size-guide-modal')?.classList.remove('open');document.body.style.overflow='';}
on($('#size-guide-modal'),'click',e=>{if(e.target===e.currentTarget)closeSizeGuide();});
on(document,'keydown',e=>{if(e.key==='Escape'){closeSizeGuide();closeMobileMenu();}});

(function initNewsletter(){
  on($('[data-newsletter-form]'),'submit',async e=>{
    e.preventDefault();
    const form=e.target;const input=form.querySelector('[type="email"]');const btn=form.querySelector('[type="submit"]');
    if(!input?.value)return;
    const original=btn.textContent;
    btn.textContent='…';btn.disabled=true;
    try{
      const res=await fetch(form.action,{method:'POST',body:new FormData(form),headers:{'Accept':'text/html'}});
      if(!res.ok)throw new Error('Subscription failed');
      showToast('Thank you for subscribing!','success');
      input.value='';
    }catch(err){
      showToast('Sorry, something went wrong. Please try again.','error');
    }
    btn.textContent=original;btn.disabled=false;
  });
})();

(function initSmoothScroll(){
  $$('a[href^="#"]').forEach(a=>{on(a,'click',e=>{const target=document.querySelector(a.getAttribute('href'));if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}});});
})();

(function initLazyLoad(){
  if(!('IntersectionObserver' in window))return;
  const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){const img=entry.target;if(img.dataset.src){img.src=img.dataset.src;delete img.dataset.src;}observer.unobserve(img);}});},{rootMargin:'200px'});
  $$('img[data-src]').forEach(img=>observer.observe(img));
})();

window.switchTab=switchTab;window.toggleCart=toggleCart;window.openMobileMenu=openMobileMenu;window.closeMobileMenu=closeMobileMenu;window.openSizeGuide=openSizeGuide;window.closeSizeGuide=closeSizeGuide;window.showToast=showToast;
function toggleSearch(){const overlay=document.getElementById('search-overlay');const isOpen=overlay.classList.toggle('open');document.body.style.overflow=isOpen?'hidden':'';if(isOpen)setTimeout(()=>document.getElementById('search-input')?.focus(),50);}
window.toggleSearch=toggleSearch;
document.addEventListener('keydown',e=>{if(e.key==='Escape'){const o=document.getElementById('search-overlay');if(o?.classList.contains('open'))toggleSearch();}});


/* Rivelia color click: show selected image */
document.addEventListener("click",function(e){if(e.target.closest(".color-option"))setTimeout(function(){var m=document.querySelector("[data-gallery-main]");if(m)m.scrollIntoView();},250)},true);


/* Rivelia remove broken links */
setTimeout(function(){["/collections/basket-femme","/collections/espadrille","/pages/guide-tailles"].forEach(function(p){document.querySelectorAll('a[href="'+p+'"],a[href$="'+p+'"]').forEach(function(a){(a.closest("li")||a).remove()})})},100);

document.querySelectorAll('.product-gallery--scroll').forEach(el => {
  el.classList.remove('product-gallery--scroll');
});



/* Rivelia product gallery arrows: static HTML buttons, simple listeners */
(function(){
  function setupGalleryArrows(gallery){
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumb'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if(!thumbs.length || (!prevBtn && !nextBtn)) return;
    if(prevBtn && prevBtn.dataset.riveliaBound) return;
    if(prevBtn) prevBtn.dataset.riveliaBound = '1';
    if(nextBtn) nextBtn.dataset.riveliaBound = '1';

    function go(dir){
      thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumb'));
      var active = thumbs.findIndex(function(t){ return t.classList.contains('active'); });
      if(active < 0) active = 0;
      var next = (active + dir + thumbs.length) % thumbs.length;
      thumbs[next].click();
      var rail = gallery.querySelector('.product-gallery__thumbs');
      if(rail && typeof rail.scrollTo === 'function'){
        rail.scrollTo({ left: thumbs[next].offsetLeft - (rail.clientWidth / 2) + (thumbs[next].clientWidth / 2), behavior: 'smooth' });
      }
    }

    if(prevBtn) prevBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(-1); });
    if(nextBtn) nextBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(1); });
  }

  function initGalleryArrows(){
    document.querySelectorAll('.product-gallery').forEach(setupGalleryArrows);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initGalleryArrows); else initGalleryArrows();
  document.addEventListener('shopify:section:load', initGalleryArrows);
})();



// --- MOBILE GALLERY SWIPE ---
(function initSwipeGallery() {
  const gallery = document.querySelector('[data-gallery]');
  const mainImg = document.querySelector('[data-gallery-main]');
  if (!gallery || !mainImg) return;

  const mainWrap = mainImg.closest('.product-gallery__main') || mainImg.parentElement;
  if (mainWrap) mainWrap.style.touchAction = 'pan-y';

  const SWIPE_THRESHOLD = 28; // px avant de valider le changement d'image (plus réactif qu'avant)
  const DRAG_DAMPING = 0.55; // ralentit légèrement le suivi du doigt pour un geste plus doux
  const DIRECTION_LOCK = 6; // px avant de déterminer si le geste est horizontal ou vertical

  let startX = 0;
  let startY = 0;
  let currentX = 0;
  let isDragging = false;
  let isHorizontal = null; // null = pas encore déterminé
  let galleryWidth = gallery.offsetWidth;

  function setTransition(enabled) {
    mainImg.style.transition = enabled ? 'transform .26s cubic-bezier(.22,.61,.36,1), opacity .26s ease' : 'none';
  }

  function getThumbs() { return [...document.querySelectorAll('[data-gallery-thumb]')]; }

  gallery.addEventListener('touchstart', e => {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    currentX = startX;
    isDragging = true;
    isHorizontal = null;
    galleryWidth = gallery.offsetWidth || 1;
    setTransition(false);
  }, { passive: true });

  gallery.addEventListener('touchmove', e => {
    if (!isDragging) return;
    currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    const dx = currentX - startX;
    const dy = currentY - startY;

    if (isHorizontal === null && (Math.abs(dx) > DIRECTION_LOCK || Math.abs(dy) > DIRECTION_LOCK)) {
      isHorizontal = Math.abs(dx) > Math.abs(dy);
    }

    if (isHorizontal) {
      // Bloque le scroll/swipe de la page UNIQUEMENT pendant un geste horizontal confirmé,
      // pour que seule l'image bouge et pas la page entière (le scroll vertical reste libre).
      e.preventDefault();
      mainImg.style.transform = `translateX(${dx * DRAG_DAMPING}px)`;
    }
  }, { passive: false });

  gallery.addEventListener('touchend', () => {
    if (!isDragging) return;
    isDragging = false;
    if (!isHorizontal) { isHorizontal = null; return; }
    isHorizontal = null;
    const diff = startX - currentX;
    setTransition(true);

    if (Math.abs(diff) < SWIPE_THRESHOLD) {
      mainImg.style.transform = 'translateX(0)';
      return;
    }

    const thumbs = getThumbs();
    const active = document.querySelector('[data-gallery-thumb].active');
    const currentIndex = thumbs.indexOf(active);
    const dir = diff > 0 ? 1 : -1; // 1 = suivant, -1 = précédent
    const nextIndex = Math.min(Math.max(currentIndex + dir, 0), thumbs.length - 1);

    if (nextIndex === currentIndex) {
      mainImg.style.transform = 'translateX(0)';
      return;
    }

    const exitX = dir > 0 ? -galleryWidth * 0.3 : galleryWidth * 0.3;
    mainImg.style.transform = `translateX(${exitX}px)`;
    mainImg.style.opacity = '0';

    setTimeout(() => {
      thumbs[currentIndex].classList.remove('active');
      thumbs[nextIndex].classList.add('active');
      mainImg.src = thumbs[nextIndex].dataset.src;
      if (thumbs[nextIndex].dataset.alt) mainImg.alt = thumbs[nextIndex].dataset.alt;
      setTransition(false);
      mainImg.style.transform = `translateX(${-exitX * 0.5}px)`;
      requestAnimationFrame(() => {
        setTransition(true);
        mainImg.style.transform = 'translateX(0)';
        mainImg.style.opacity = '1';
      });
    }, 200);
  }, { passive: true });
})();

/* Rivelia: demi-pointures mocassin beige a gland, element interne */
(function(){
  if(location.pathname !== '/products/mocassin-en-daim-beige-a-gland') return;

  function fixHalfSizeSpans(){
    document.querySelectorAll('span.variant-option').forEach(function(option){
      var raw = (option.textContent || '').trim();
      if(!/^\d+\.\d+$/.test(raw)) return;

      var label = option.closest('label');
      var input = label && label.previousElementSibling;
      var selected = input && input.checked;

      option.style.setProperty('font-size', '13px', 'important');
      option.style.setProperty('width', '44px', 'important');
      option.style.setProperty('height', '40px', 'important');
      option.style.setProperty('padding', '7px 14px', 'important');
      option.style.setProperty('border-radius', '2px', 'important');
      option.style.setProperty('border', '0.5px solid #e5e0d8', 'important');
      option.style.setProperty('background', selected ? '#111111' : 'transparent', 'important');
      option.style.setProperty('color', selected ? '#ffffff' : '#111111', 'important');
      option.style.setProperty('display', 'inline-block', 'important');

      if(label) label.style.setProperty('width', '44px', 'important');
    });
  }

  fixHalfSizeSpans();
  document.addEventListener('change', fixHalfSizeSpans);
  document.addEventListener('shopify:section:load', fixHalfSizeSpans);
  new MutationObserver(fixHalfSizeSpans).observe(document.documentElement, {childList:true, subtree:true});
})();

/* Rivelia community auto-scroll (infinite loop) */
(function(){
  const track = document.querySelector('[data-community-scroll]');
  if(!track) return;
  let paused = false;
  const halfWidth = () => track.scrollWidth / 2;

  track.addEventListener('mouseenter', ()=>paused=true);
  track.addEventListener('mouseleave', ()=>paused=false);
  track.addEventListener('touchstart', ()=>paused=true, {passive:true});
  track.addEventListener('touchend', ()=>paused=false);

  function loop(){
    if(!paused){
      track.scrollLeft += 0.5;
      if(track.scrollLeft >= halfWidth()) track.scrollLeft = 0;
    }
    requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);
})();

/* Rivelia sticky mobile ATC bar + size picker */
(function(){
  const bar = document.querySelector('[data-sticky-atc]');
  const realBtn = document.querySelector('[data-atc-btn]');
  if(!bar || !realBtn) return;

  let paused = false;
  const io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      bar.classList.toggle('show', !e.isIntersecting && window.innerWidth <= 768);
    });
  }, {threshold: 0});
  io.observe(realBtn);
  window.addEventListener('resize', function(){ if(window.innerWidth > 768) bar.classList.remove('show'); });

  const priceEl = document.querySelector('[data-product-price]');
  const stickyPrice = bar.querySelector('[data-sticky-atc-price]');
  if(priceEl && stickyPrice){
    new MutationObserver(function(){ stickyPrice.textContent = priceEl.textContent; })
      .observe(priceEl, {childList:true, characterData:true, subtree:true});
  }

  const mainImg = document.querySelector('[data-gallery-main]');
  const stickyImg = bar.querySelector('[data-sticky-atc-img]');
  if(mainImg && stickyImg){
    new MutationObserver(function(){ stickyImg.src = mainImg.src; })
      .observe(mainImg, {attributes:true, attributeFilter:['src']});
  }

  bar.querySelector('[data-sticky-atc-btn]').addEventListener('click', function(){ realBtn.click(); });

  /* --- Size picker --- */
  const sizeBtn = document.querySelector('[data-sticky-atc-size-btn]');
  const sizeLabelEl = sizeBtn ? sizeBtn.querySelector('[data-sticky-atc-size]') : null;
  const panel = document.querySelector('[data-sticky-atc-size-panel]');
  if(!sizeBtn || !panel) return;

  let overlay = document.querySelector('.rivelia-sticky-atc__overlay');
  if(!overlay){
    overlay = document.createElement('div');
    overlay.className = 'rivelia-sticky-atc__overlay';
    document.body.appendChild(overlay);
  }

  function findRealSizeSection(){
    return Array.from(document.querySelectorAll('.variant-section.product-variant-block')).find(function(sec){
      return sec.querySelector('.product-size-button__label');
    });
  }

  function buildPanel(){
    const realSection = findRealSizeSection();
    if(!realSection) return;
    const chips = Array.from(realSection.querySelectorAll('.product-size-button__label'));
    let html = '<div class="rivelia-sticky-atc__size-panel-title"><span>Choose a size</span><button type="button" class="rivelia-sticky-atc__size-panel-close" data-close-panel>&times;</button></div><div class="rivelia-sticky-atc__size-grid">';
    chips.forEach(function(chip){
      const val = chip.getAttribute('data-option-value');
      const isActive = chip.classList.contains('active');
      const isSoldout = chip.classList.contains('soldout');
      html += '<button type="button" class="rivelia-sticky-atc__size-chip' + (isActive?' active':'') + (isSoldout?' soldout':'') + '" data-size-value="' + val + '"' + (isSoldout?' disabled':'') + '>' + val + '</button>';
    });
    html += '</div>';
    panel.innerHTML = html;
  }

  function updateSizeLabel(){
    const realSection = findRealSizeSection();
    if(!realSection || !sizeLabelEl) return;
    const activeChip = realSection.querySelector('.product-size-button__label.active');
    sizeLabelEl.textContent = activeChip ? ('Size ' + activeChip.getAttribute('data-option-value')) : 'Size';
  }

  function openPanel(){
    buildPanel();
    panel.classList.add('open');
    overlay.classList.add('open');
    sizeBtn.classList.add('open');
  }
  function closePanel(){
    panel.classList.remove('open');
    overlay.classList.remove('open');
    sizeBtn.classList.remove('open');
  }

  sizeBtn.addEventListener('click', openPanel);
  overlay.addEventListener('click', closePanel);
  panel.addEventListener('click', function(e){
    if(e.target.closest('[data-close-panel]')){ closePanel(); return; }
    const chip = e.target.closest('[data-size-value]');
    if(!chip || chip.disabled) return;
    const val = chip.getAttribute('data-size-value');
    const realSection = findRealSizeSection();
    if(!realSection) return;
    const realChip = Array.from(realSection.querySelectorAll('.product-size-button__label')).find(function(c){ return c.getAttribute('data-option-value') === val; });
    if(realChip) realChip.click();
    setTimeout(function(){ updateSizeLabel(); closePanel(); }, 150);
  });

  updateSizeLabel();
  document.addEventListener('click', function(e){
    if(e.target.closest('.variant-option, .product-size-button__label')) setTimeout(updateSizeLabel, 100);
  });
})();
